import { render, staticRenderFns } from "./ProductAnalyticsIndex.vue?vue&type=template&id=c0369f9a&"
import script from "./ProductAnalyticsIndex.vue?vue&type=script&lang=js&"
export * from "./ProductAnalyticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports